import { render, staticRenderFns } from "./fallbackpage.vue?vue&type=template&id=356d8a10&"
import script from "./fallbackpage.vue?vue&type=script&lang=js&"
export * from "./fallbackpage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports